"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMUNITY_NAMES = void 0;
exports.COMMUNITY_NAMES = {
    SANDALWOOD: 'Sandalwood'
};
